export default __webpack_public_path__ + "static/media/dottedBGLarge.e6fc39d6.png";